import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getPortraitlibApi, getDeviceTreeApi, addRuleApi, getRuleApi, updateRuleApi } from '@blade-sxp/account/api/attendanceMag';
import { dealTree } from '@blade-sxp/account/utils/attendanceMag';
export const useAttendanceMagStore = defineStore('attendanceMagStore', () => {
    const portraitLibList = ref([]); // 库列表
    const deviceTree = ref([]); // 设备树
    const attendanceRule = ref([]); // 显示规则
    // 获取人像库列表
    const getPortraitlibList = async () => {
        try {
            const res = await getPortraitlibApi();
            portraitLibList.value = res.list;
            return res;
        }
        catch (e) {
            throw e;
        }
    };
    // 获取设备树
    const getDeviceTree = async () => {
        try {
            const res = await getDeviceTreeApi();
            deviceTree.value = dealTree(res);
            return res;
        }
        catch (e) {
            throw e;
        }
    };
    // 添加考勤规则
    const addRule = async (data) => {
        try {
            const res = await addRuleApi(data);
            return res;
        }
        catch (e) {
            throw e;
        }
    };
    const getRule = async () => {
        try {
            const res = await getRuleApi();
            attendanceRule.value = res;
            return res;
        }
        catch (e) {
            throw e;
        }
    };
    const updateRule = async (data) => {
        try {
            const res = await updateRuleApi(data);
            return res;
        }
        catch (e) {
            throw e;
        }
    };
    return { portraitLibList, getDeviceTree, getPortraitlibList, deviceTree, addRule, getRule, updateRule, attendanceRule };
});
